/**
 * 程序升级公告模态框
 * 创建时间：2017-07-03
 * 创建人：Shujuan Sun
 */
<template>
  		<div class="popup_box">
		  <div class="sub_update">
		    <div class="update">
		      <div class="update_main">
		        <div class="update_logo"></div>
		        <div class="update_title"></div>
		        <div class="update_text">
			        <!--<p>此次更新如下： </p>-->
			        <em  v-html="versionInfo.content"></em> 
		        </div>	          
		           <div class="update_btn02" >
		           		<em>
        					<input type="checkbox" v-model="stopRemind"/>
       	 					<i>以后不再提醒</i>
		           		</em>
		           		<router-link to="/indexUpdate" target="_blank">更新详情</router-link>
		           </div> 
        			<div class="update_btn" > 
        				<span><a @click="startUse">开始使用</a></span>
        			</div>
		        </div>
		    </div>
		  </div>
		</div>
</template>
<script>
export default {
  name: 'UpdateList',
  props:['versionInfo'],
  data(){
  	return {
  		stopRemind:false
  	}
  },
  methods:{
  	startUse(){
  		this.$emit('startUse',this.stopRemind)
  	}
  }
  
}
</script>
<style>
/* 弹出更新提示开始 */
.popup_box{ position:fixed; top:0px; width:100%; background:rgba(0,0,0,0.5); height:100%;  z-index:99;    }
.sub_update {
	height: 100%; display: flex; justify-content:center; align-items:center;  width: 100%;
	/*height:100%;
	display: -webkit-box;
	display: -moz-box;
	display: box;
	box-align: center;
	-webkit-box-align:center; 
	-moz-box-align:center;
	-o-box-align: center;
	-webkit-box-pack: center;
	-moz-box-pack: center;
	box-pack: center; 
	width:100%;*/ }
.update {border:10px solid rgba(255,255,255,0.3);  width:460px; margin:0 auto; text-align:center; }
.update_main { background:#fff;}
.update img { display:block;}
.update_logo { height:90px; width:100%; background:url(../../assets/project/images/update_logo.png) left no-repeat;}
.update_title { height:36px; margin:0 25px; margin-top:20px;  background:url(../../assets/project/images/update_title.png) #fff center center no-repeat;}
.update_text { padding:15px 25px; text-align:left;  }
.update_text p {  font-size:16px; padding-bottom:10px; }
.update_text em {max-height:180px; display:block; overflow:auto;}
.update_text span { padding:5px 0; display:block; line-height:20px; color:#666; font-size:14px;}
.update_btn { padding:10px 25px 27px; overflow:hidden;}
.update_btn span,.update_btn em{ box-sizing:border-box; float:left; width:100%; }
.update_btn span {}
.update_btn em { padding-left:5px;}
.update_btn a{ height:36px; line-height:36px; font-size:16px; color:#2D8AE3 !important; border:1px solid #2D8AE3; display:block;}

.update_btn02 { padding:15px 25px 5px ; text-align:left;}
.update_btn02 em { color:#666;}
.update_btn02 a { float:right; color:#2D8AE3 !important;}

/* 弹出更新提示结束 */
@media screen and (max-width: 500px) {
	.update {  width:400px;  }
}
@media screen and (max-width: 440px) {
	.update {  width:360px;  }
}
@media screen and (max-width: 400px) {
	.update {  width:320px;  }
}
</style>



// WEBPACK FOOTER //
// UpdateList.vue?e17e3dac